<template>
  <hypto-popup title="UPI Prefixes" :footer="false">
    <template v-slot:body>
      <unprivilege-panel v-if="getterUnprivilegePage === 'UPI Prefixes'" />

      <div v-else class="formal-table">
        <div class="row" v-for="(data, index) in upiPrefixes" :key="index">
          <p>
            <b>Prefix:</b>{{data.prefix}}
          </p>
          <p class="r-text">
            <b>Purpose:</b>{{data.purpose}}
          </p>
          <p class="grey-text">{{data.status}}</p>
          <p>{{data.created_at}}</p>
        </div>
      </div>

      <table-loader v-if="!getterUnprivilegePage &&
                    (!paginate.data_added || upiPrefixes.length < paginate.total)"
                    :css="'border-layout'" :clearResponse="false" />
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import UnprivilegePanel from '@/components/global/UnprivilegePanel'
import TableLoader from '@/components/global/TableLoader'

import ApiServices from '@/services/api/upi'
import { onScroll } from '@/utils/helpers'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'UpiPrefixList',
  components: { HyptoPopup, UnprivilegePanel, TableLoader },
  data () {
    return {
      upiPrefixes: [],
      paginate: {
        start: 0,
        data_added: false,
        total: null
      }
    }
  },
  created () {
    this.SET_UNPRIVILEGE_PAGE(null)
    this.upiPrefixList()
  },
  computed: {
    ...mapGetters(['getterUnprivilegePage'])
  },
  methods: {
    onScroll,
    ...mapMutations(['SET_UNPRIVILEGE_PAGE']),
    upiPrefixList (start) {
      this.fetchRecords(start).then(() => {
        this.onScroll(this.paginate, this.upiPrefixList, '.formal-table .row')
      })
    },
    fetchRecords (start) {
      return new Promise(resolve => {
        let params = {}
        if (start) {
          params['offset'] = start
        }

        ApiServices.upiPrefixList(params).then((response) => {
          let data = response.data
          if (data) {
            if (start) {
              this.upiPrefixes.push(...response.data.upi_prefixes)
            } else {
              this.upiPrefixes = data.upi_prefixes
              this.paginate = {
                start: 0,
                total: data.total,
                page_size: data.page_size,
                data_added: true
              }
            }
            resolve()
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .formal-table {
    .row {
      display: grid;
      grid-template-columns: auto auto;
      grid-gap: 5px;
      border-bottom: 2px solid $grey-outline;
      padding: 5px 0;
      justify-content: space-between;
      margin: 5px 0;

      p {
        @include normal-text($secondary, 15px);
        white-space: nowrap;
        text-align: left;

        &.grey-text {
          color: $grey-text;
        }
        &.r-text {
          text-align: right;
        }

        b {
          margin-right: 6px;
        }
      }
    }
  }

  .mobile {
    p {
      font-size: 14px !important;
    }
  }
</style>
